import { FilterFunction } from '../interfaces/FilterFunction';

export function createBooleanFilterFunction<T>(predicate: (item: T) => boolean): FilterFunction<T, boolean> {
  return (item: T, value: boolean) => predicate(item) === value;
}
